import React, { Component } from "react";
import { Container } from "reactstrap";
import FormReglaNegocioC from "./FormReglaNegocioC";
import { connect } from "react-redux";
import { postReglaNegocioCreate } from "./ReglaNegocioAction";
import swal from "sweetalert";
import { withRouter } from 'react-router-dom';
import { TabContent, TabPane, Nav, NavLink, NavItem } from "reactstrap";
import classnames from 'classnames';
import { Link } from "react-router-dom";

const mapStateToProps = (state) => {
    return {
        getResponDataReglaNegocioC: state.ReglaNegocioReducer.getResponDataReglaNegocioC,
        errorResponReglaNegocioC: state.ReglaNegocioReducer.errorResponReglaNegocioC,
    };
};

class ReglaNegocioCreateContainer extends Component {

    constructor(props) {
        super(props);
        this.state = {
            activeTab: 1,
            show: false,
        };
    }


    handleSubmit(data) {
        this.props.dispatch(postReglaNegocioCreate(data));
    }

	render() {
		const { activeTab } = this.state

		if (this.props.getResponDataReglaNegocioC || this.props.errorResponDataReglaNegocioC) {

			if (this.props.errorResponDataReglaNegocioC) {
				swal("Fallido!", this.props.errorResponDataReglaNegocioC, "Error");
			} else {
				swal({
					title: "¡Regla Creada!",
					icon: "success",
					button: "Enterado"
				}
				)
				.then((willDelete) => {
					this.props.history.push("/reglasestablecidas");
				});
			}//END ELSE

		}//END IF

		return (
			<>
				<div className="section-body">
					<div className="container-fluid">
						<div className="d-flex justify-content-between align-items-center ">
							<div className="header-action">
								<h1 className="page-title">Reglas Establecidas</h1>
								<ol className="breadcrumb page-breadcrumb">
									<li className="breadcrumb-item"><a href="#">Administrativo</a></li>
									<li className="breadcrumb-item active" aria-current="page">CREAR</li>
								</ol>
							</div>
							<Nav tabs className="page-header-tab">
								<NavItem>
									<Link to={"/reglasestablecidas"}>Listar Regla Negocio</Link>
								</NavItem>
							</Nav>

						</div>
					</div>
				</div>

				<div className="section-body mt-4">
					<div className="container-fluid">
						<TabContent activeTab={activeTab}>

							<TabPane tabId={1} className={classnames(['fade show'])}>


								<div className="row clearfix">
									<div className="col-lg-12 col-md-12 col-sm-12">
										<div className="card">
											<div className="card-header">
												<h3 className="card-title">Crear Servicios IEC</h3>
												<div className="card-options ">
													<a href="#" className="card-options-collapse" data-toggle="card-collapse"><i className="fe fe-chevron-up"></i></a>
													<a href="#" className="card-options-remove" data-toggle="card-remove"><i className="fe fe-x"></i></a>
												</div>
											</div>

											<FormReglaNegocioC onSubmit={(data) => this.handleSubmit(data)} />

										</div>
									</div>

								</div>

							</TabPane>


						</TabContent>
					</div>
				</div>

			</>
		);

	}// END RENDER



}//END CLASS

export default connect(mapStateToProps, null)(ReglaNegocioCreateContainer);